// Guided tour of the People & Compliance Plan, shown once to each person who
// opens it. The ID never changes: it is the key progress is stored under.
export const PEOPLE_PLAN_TOUR_ID = 'people-plan';

export const peoplePlanTourSteps = [
  {
    title: 'Welcome to the People & Compliance Plan',
    target: '[data-tour="page-header"]',
    body: [
      'This is the plan HR and the SLT keep of performance, pay, governance, culture and certification work. It replaces the plan El and Harry B kept as a Claude artifact.',
      'Everything here is saved for everyone who can open the page.',
    ],
  },
  {
    title: 'A rolling window',
    target: '[data-tour="window"]',
    body: [
      'The plan shows last month and the next fourteen by default, and moves forward on its own each month.',
      'Change the months to look further ahead or back. Today puts it back.',
    ],
  },
  {
    title: 'Five views of one plan',
    target: '[data-tour="tabs"]',
    body: [
      'Timeline shows when each item happens. Workload shows how many days that puts on each person each month. All items is the list, Standing commitments holds the regular meetings, and People holds capacity.',
    ],
  },
  {
    title: 'Whose work is it?',
    target: '[data-tour="person-filter"]',
    body: [
      'Pick a person to see only the items they own, are involved in, sign off or carry effort on, including through a group such as Line managers.',
    ],
  },
  {
    title: 'Restricted items',
    target: '[data-tour="view"]',
    when: (c) => c.canRestricted,
    body: [
      'Items marked SLT only (pay, bonus, org chart, succession) are seen by the SLT and Harry B alone. Preview the company view to check what everybody else sees.',
    ],
  },
  {
    title: 'Estimates to check',
    target: '[data-tour="add-item"]',
    body: [
      'Add an item here. Effort you are unsure of can be ticked as an estimate, and the count of items with estimates appears beside the window until someone confirms them.',
      'Export to Excel gives you the whole plan as a workbook.',
    ],
  },
];
